/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocArrowSyncIcon16Light } from './DocArrowSyncIcon16Light';
import { DocArrowSyncIcon16Regular } from './DocArrowSyncIcon16Regular';
import { DocArrowSyncIcon16Solid } from './DocArrowSyncIcon16Solid';
import { DocArrowSyncIcon20Light } from './DocArrowSyncIcon20Light';
import { DocArrowSyncIcon20Regular } from './DocArrowSyncIcon20Regular';
import { DocArrowSyncIcon20Solid } from './DocArrowSyncIcon20Solid';
import { DocArrowSyncIcon24Regular } from './DocArrowSyncIcon24Regular';
import { DocArrowSyncIcon24Solid } from './DocArrowSyncIcon24Solid';
import { DocArrowSyncIcon32Regular } from './DocArrowSyncIcon32Regular';
import { DocArrowSyncIcon64Regular } from './DocArrowSyncIcon64Regular';
var sizes = {
    16: {
        light: DocArrowSyncIcon16Light,
        regular: DocArrowSyncIcon16Regular,
        solid: DocArrowSyncIcon16Solid,
    },
    20: {
        light: DocArrowSyncIcon20Light,
        regular: DocArrowSyncIcon20Regular,
        solid: DocArrowSyncIcon20Solid,
    },
    24: {
        regular: DocArrowSyncIcon24Regular,
        solid: DocArrowSyncIcon24Solid,
    },
    32: {
        regular: DocArrowSyncIcon32Regular,
    },
    64: {
        regular: DocArrowSyncIcon64Regular,
    },
};
export var DocArrowSyncIcon = forwardRef('DocArrowSyncIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
